
// contacts and previousEducations need to be grouped by type (or some other key)
const infoReducer = (typeKey) => (data) => data.reduce(
  (acc, val) => {
      if (Object.prototype.hasOwnProperty.call(acc, val[typeKey])) {
          acc[val[typeKey]] = [...acc[val[typeKey]], val];
          return acc;
      }
      acc[val[typeKey]] = [val];
      return acc;
  }, {});

export const contactReducer = infoReducer('type');
export const previousEducationReducer = infoReducer('educationLevel');

// Resolves the display name of a raw lookup entity (e.g. LKPGender, LKPCountry, LKPStudyCycle) for the
// active locale, using its `translations` array (already shipped by the backend for these entities),
// falling back to the base (Bosnian) `name` when no translation matches or none exist.
export const getLookupName = (lookup) => {
    if (!lookup) return '';
    if (window.$locale !== 'bs' && lookup.translations && lookup.translations.length) {
        const translation = lookup.translations.find(e => e.language === window.$locale);
        if (translation) return translation.name;
    }
    return lookup.name;
};

export default { contactReducer, previousEducationReducer, getLookupName };



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/util.js